export const getThumbnail = (videoId) => {
    return `https://i3.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
}
